export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";
export const USER_REGISTER_RESET = "USER_REGISTER_RESET"

export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAIL = "USER_DETAILS_FAIL";
export const USER_DETAILS_RESET = "USER_DETAILS_RESET";

export const USER_UPDATE_PROFILE_REQUEST = "USER_UPDATE_PROFILE_REQUEST";
export const USER_UPDATE_PROFILE_SUCCESS = "USER_UPDATE_PROFILE_SUCCESS";
export const USER_UPDATE_PROFILE_FAIL = "USER_UPDATE_PROFILE_FAIL";
export const USER_UPDATE_PROFILE_RESET = "USER_UPDATE_PROFILE_RESET";

export const USER_UPDATE_IMAGE_REQUEST = "USER_UPDATE_IMAGE_REQUEST";
export const USER_UPDATE_IMAGE_SUCCESS = "USER_UPDATE_IMAGE_SUCCESS";
export const USER_UPDATE_IMAGE_FAIL = "USER_UPDATE_IMAGE_FAIL";

export const USER_EMAIL_RESET_PASSWORD_REQUEST = "USER_EMAIL_RESET_PASSWORD_REQUEST";
export const USER_EMAIL_RESET_PASSWORD_SUCCESS = "USER_EMAIL_RESET_PASSWORD_SUCCESS";
export const USER_EMAIL_RESET_PASSWORD_FAIL = "USER_EMAIL_RESET_PASSWORD_FAIL";
export const USER_EMAIL_RESET_PASSWORD_RESET = "USER_EMAIL_RESET_PASSWORD_RESET"

export const USER_PASSWORD_RESET_REQUEST = "USER_PASSWORD_RESET_REQUEST";
export const USER_PASSWORD_RESET_SUCCESS = "USER_PASSWORD_RESET_SUCCESS";
export const USER_PASSWORD_RESET_FAIL = "USER_PASSWORD_RESET_FAIL";
